import { proxy } from 'valtio';

interface VoiceState {
	isConnected: boolean;
	isConnecting: boolean;
	isTesting: boolean;
	isMuted: boolean;
	isAssistantSpeaking: boolean;
	volumeLevel: number;
	showTools: boolean;
	showTranscript: boolean;
	previousVolume: number;
	micStream: MediaStream | null;
}

export const voiceStore = proxy<VoiceState>({
	isConnected: false,
	isConnecting: false,
	isTesting: false,
	isMuted: false,
	isAssistantSpeaking: false,
	volumeLevel: 0,
	showTools: false,
	showTranscript: false,
	previousVolume: 0,
	micStream: null,
});

// Actions
export const voiceActions = {
	setConnected: (connected: boolean) => {
		voiceStore.isConnected = connected;
	},
	setConnecting: (connecting: boolean) => {
		voiceStore.isConnecting = connecting;
	},
	setTesting: (testing: boolean) => {
		voiceStore.isTesting = testing;
	},
	setMicStream: (stream: MediaStream | null) => {
		voiceStore.micStream = stream;
	},
	toggleMute: () => {
		console.log('🔇 [VoiceStore] Toggling mute:', {
			currentMuteState: voiceStore.isMuted,
			hasMicStream: !!voiceStore.micStream,
			trackCount: voiceStore.micStream?.getAudioTracks().length,
		});

		// Toggle the mute state
		voiceStore.isMuted = !voiceStore.isMuted;

		// If we have a stream, update all its tracks
		if (voiceStore.micStream) {
			const tracks = voiceStore.micStream.getAudioTracks();
			tracks.forEach((track) => {
				track.enabled = !voiceStore.isMuted;
				console.log('🎤 [VoiceStore] Track state updated:', {
					trackLabel: track.label,
					enabled: track.enabled,
					muted: voiceStore.isMuted,
				});
			});
		}
	},
	setAssistantSpeaking: (speaking: boolean) => {
		voiceStore.isAssistantSpeaking = speaking;
	},
	setVolumeLevel: (level: number) => {
		if (!voiceStore.isMuted) {
			voiceStore.volumeLevel = level;
		}
	},
	toggleTools: () => {
		voiceStore.showTools = !voiceStore.showTools;
	},
	toggleTranscript: () => {
		voiceStore.showTranscript = !voiceStore.showTranscript;
	},
	reset: () => {
		if (voiceStore.micStream) {
			voiceStore.micStream.getTracks().forEach((track) => track.stop());
		}
		voiceStore.isConnected = false;
		voiceStore.isConnecting = false;
		voiceStore.isTesting = false;
		voiceStore.isMuted = false;
		voiceStore.isAssistantSpeaking = false;
		voiceStore.volumeLevel = 0;
		voiceStore.previousVolume = 0;
		voiceStore.micStream = null;
	},
};
